import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import {ReactComponent as ThumbsUp} from '../assets/img/thumbs-up.svg';
import {ReactComponent as ThumbsDown} from '../assets/img/thumbs-down.svg';
import { AUTOPILOT_URL } from '../constants';

import '../assets/css/rating.css';

const ChatRating = ({conversationId, lastMessage, companyConfig}) => {
  const { t } = useTranslation();
  const [selectedRating, setSelectedRating] = useState(0);

  const sendRating = useCallback(async (rating) => {
    if (!lastMessage.id) {
      return;
    }

    const url = `${AUTOPILOT_URL}/chat/v1/conversation/rate`;
    const body = {
      'conversation_id': conversationId,
      'message_id': lastMessage.id,
      'rating': rating,
    };
    await axios.post(url, body);
  }, [lastMessage]);

  useEffect(() => {
    if (selectedRating === 0) {
      if (lastMessage.rating === null) {
        void sendRating(null);
      }

      setSelectedRating(lastMessage.rating || null);
    } else if (selectedRating !== null && selectedRating !== 0 && selectedRating !== lastMessage.rating) {
      void sendRating(selectedRating);
    }
  }, [selectedRating, lastMessage, sendRating]);

  return (
    <div className="ChatRatingContainer">
      <span tabIndex={0}>{t('CSAT.question', 'Did we resolve your issue?')}</span>
      <span className="ChatRatingStarsContainer">
        <button
          onClick={() => setSelectedRating(1)}
          className={'ChatRatingUp ' + (selectedRating === 1 ? 'active' : '')}
        >
          <ThumbsUp/>
        </button>
        <button
          onClick={() => setSelectedRating(-1)}
          className={'ChatRatingDown ' + (selectedRating === -1 ? 'active' : '')}
        >
          <ThumbsDown/>
        </button>
      </span>
    </div>
  );
};

export default ChatRating;
